// Shared palette for the review/share surfaces (TSX + SCSS).
// The SCSS files duplicate these hex values in $status-* variables — keeping a
// single source here is the lighter alternative to wiring CSS to TS through
// the build, until the design system ships review-state tokens.
export const REVIEW_STATUS_COLORS = {
  pending: '#e0a400',
  approved: '#2e7d5b',
  declined: '#c0392b'
} as const
